// =============================================================================
// LIL & CO — Services Supabase : WhatsApp inbox (super admin)
// =============================================================================
// Résilient : renvoie ok/erreur, ne jette jamais.
//   • `whatsapp_sessions` / `whatsapp_messages` (RLS super_admin) : lecture ;
//   • `whatsapp-reply` (Edge Function, JWT super_admin) : réponse texte libre
//      dans la fenêtre 24h (refuse au-delà — template requis).
// L'inbound + la 1re réponse auto sont gérés par la fonction `whatsapp-webhook`.
// =============================================================================
import { supabase } from './supabase';
import type { WaSession, WaMessage } from './whatsappInbox';

export interface LoadSessionsResult { ok: boolean; sessions: WaSession[]; error?: string; }

export async function loadWaSessions(limit = 200): Promise<LoadSessionsResult> {
  const { data, error } = await supabase
    .from('whatsapp_sessions')
    .select('id,wa_id,tenant_id,contact_name,last_inbound_at,window_expires_at,first_reply_sent,opted_in_marketing,opted_in_at,converted,created_at,updated_at')
    .order('last_inbound_at', { ascending: false, nullsFirst: false })
    .limit(limit);
  if (error) return { ok: false, sessions: [], error: error.message };
  return { ok: true, sessions: (data ?? []) as WaSession[] };
}

export interface LoadMessagesResult { ok: boolean; messages: WaMessage[]; error?: string; }

export async function loadWaMessages(waId: string, limit = 200): Promise<LoadMessagesResult> {
  const { data, error } = await supabase
    .from('whatsapp_messages')
    .select('id,tenant_id,wa_id,direction,body,wa_message_id,status,created_at')
    .eq('wa_id', waId)
    .order('created_at', { ascending: true })
    .limit(limit);
  if (error) return { ok: false, messages: [], error: error.message };
  return { ok: true, messages: (data ?? []) as WaMessage[] };
}

export interface ReplyResult { ok: boolean; message: string; }

/** Envoie une réponse texte libre (relais humain) dans la fenêtre 24h. */
export async function sendWaReply(waId: string, text: string, tenantSlug?: string): Promise<ReplyResult> {
  const clean = text.trim();
  if (!clean) return { ok: false, message: 'Message vide.' };
  const { data, error } = await supabase.functions.invoke('whatsapp-reply', {
    body: { wa_id: waId, text: clean, ...(tenantSlug ? { tenant_slug: tenantSlug } : {}) },
  });
  if (error) return { ok: false, message: error.message };
  const d = (data ?? {}) as Record<string, unknown>;
  if (!d.ok) return { ok: false, message: String(d.error ?? 'Échec de l’envoi.') };
  return { ok: true, message: 'Message envoyé.' };
}
